export default __webpack_public_path__ + "static/media/Gender_Male.bc99d3e8.svg";